import type { LayoutLoad } from './$types';
import {dev} from '$app/environment';
import * as Sentry from '@sentry/svelte';

export const ssr = false;

if (!dev) {
  Sentry.init({
    dsn: 'https://5e34660298e0bc0abee24f9fa3b38fb7@o4508740400513025.ingest.us.sentry.io/4510319150563328',
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/svelte/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],

    // Capture Replay for 10% of all sessions,
    // plus 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export const load: LayoutLoad = () => ({
  meta: {
    appTitle: 'Clinical Skills Leaderboard',
  }
});
